import { actions as buildsActions } from '@saucelabs/sl-module-builds';
import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { utils as authUtils } from '@saucelabs/sl-container-authentication';
import { api as jobsApi } from '@saucelabs/sl-module-jobs';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as constants from './constants';
import { stopBuildSelector } from './selectors';


const getFromDatetime = () => Math.round(new Date().getTime() / 1000);
let instance;
let lastFromDatetime = getFromDatetime();

export const subscribeBuild = ({ id }) => (dispatch) => {
  if (instance) return null;
  dispatch(actions.startSubscribeBuild());
  instance = () => {
    // By doing it we can easily update job status counters
    dispatch(buildsActions.getBuildById({ id }));
    // We want to get more detailed informations about in progress jobs
    dispatch(buildsActions.getBuildUpdatedJobs(
      { id, full: true, from: lastFromDatetime },
      { skipErrorPage: true },
    ))
      .then(() => {
        lastFromDatetime = getFromDatetime();
      });
    const timeoutId = setTimeout(() => instance && instance(), constants.POLLING_TIMEOUT_MS);
    dispatch(actions.saveBuildsTimeout(timeoutId));
  };
  return instance();
};

export const unsubscribeBuild = () => (dispatch) => {
  dispatch(actions.stopSubscribeBuild());
  instance = null;
};

export const fetchRecurringJobs = ({ id, skip = 0 }) => (dispatch) => (
  dispatch(buildsActions.getBuildJobs({
    id, skip, full: true, limit: constants.BUILD_FETCH_OFFSET,
  }))
    .then(({ data }) => (
      data.truncated ?
        dispatch(fetchRecurringJobs({ id, skip: skip + constants.BUILD_FETCH_OFFSET })) :
        Promise.resolve()
    ))
);

export const initialize = ({ id }) => (dispatch, getState) => (
  Promise.all([
    dispatch(buildsActions.getBuildJobs({
      id, full: true, skip: 0, limit: constants.BUILD_FETCH_OFFSET,
    })),
    dispatch(buildsActions.getBuildById({ id })),
  ]).then(([jobsResponse]) => {
    const state = getState();
    const isAuthenticatedUser = state.user.isAuthenticated();
    const isPublicBuild = state.apps.builds.getIn(['build', 'public']);
    const currentPathname = state.router.location.pathname;

    if (!isAuthenticatedUser && !isPublicBuild) {
      throw authUtils.redirectToMainLogin(currentPathname);
    }

    return jobsResponse;
  }).then((jobsResponse) => {
    dispatch(recordTrack('Automated Build Test Viewed', { id }));
    if (jobsResponse.data.truncated) {
      // lets fetch all build jobs first
      dispatch(fetchRecurringJobs({ id, skip: constants.BUILD_FETCH_OFFSET }))
        .then(() => dispatch(subscribeBuild({ id })));
    } else {
      // since we have all jobs fetched, we can start to update jobs
      dispatch(subscribeBuild({ id }));
    }
  })
);

export const stopBuild = () => (dispatch, getState) => {
  const { buildOwner, runningJobsIds } = stopBuildSelector(getState());

  return Promise
    .all(runningJobsIds.map((id) => jobsApi.stopJob({ id, username: buildOwner })))
    .then(() => dispatch(notificationActions.notifyInfo('Stopping running tests from this build')));
};

export const cleanup = () => (dispatch) => {
  dispatch(actions.cleanup());
  dispatch(unsubscribeBuild());
};
